import { createSlice } from "@reduxjs/toolkit";
import { getListGiftExchangeForCustomerHistories } from "../../api/giftExchange/giftExchange";

// giá trị khởi tạo của state
const initialState = {
  listGiftExchangeForCustomerHistories: [],
  isLoadGiftExchangeForCustomerHistories: false,
  currentPage: 1,
  pageSize: 10,
  error: null,
  totalRecords: 0, // Tổng số bản ghi từ API
};

const giftExchangeForCusHistorySlice = createSlice({
  name: "giftExchangeForCusHistories", // tên phân biệt giữa các reduce
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload; // Sửa lỗi gán nhầm `pageSize`
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListGiftExchangeForCustomerHistories.pending, (state) => {
        // api đnag pending chờ xử lý
        state.isLoadGiftExchangeForCustomerHistories = true;
        state.error = null;
      })
      .addCase(getListGiftExchangeForCustomerHistories.fulfilled, (state, action) => {
        // api trả về thành công thì trả ra
        state.isLoadGiftExchangeForCustomerHistories = false;
        state.listGiftExchangeForCustomerHistories = action.payload.data || [];
        state.currentPage = action.payload.current_page; // Cập nhật trang hiện tại từ API
        state.pageSize = action.payload.per_page; // Cập nhật số bản ghi mỗi trang
        state.totalRecords = action.payload.total; // Cập nhật tổng số bản ghi
      })
      .addCase(getListGiftExchangeForCustomerHistories.rejected, (state, action) => {
        // api trả về thất bại thì trả ra
        state.isLoadGiftExchangeForCustomerHistories = false;
        state.error = action.payload;
      });
  },
});

export const { setCurrentPage, setPageSize, setTotalRecords } =
  giftExchangeForCusHistorySlice.actions;
export default giftExchangeForCusHistorySlice.reducer;
